import { AlertTriangle } from "lucide-react";

const DISCLAIMER_TEXT = `Compass is a personal development tool designed to support reflection, clarity, and intentional action.

It does not provide medical, psychological, or professional advice.

If you are experiencing mental health challenges, please seek support from a qualified professional.

By using this app, you acknowledge that all decisions and actions remain your responsibility.`;

// Short version for footer and compact areas
export const DisclaimerShort = ({ className = "" }) => (
  <p className={`text-xs font-bold ${className}`} style={{ color: '#ffffff' }}>
    Compass is a personal development tool, not a substitute for professional advice.
  </p>
);

// Full disclaimer for signup and settings
export const DisclaimerFull = ({ className = "" }) => (
  <div className={`p-4 rounded-xl bg-[#f0e8d8] border border-[#d8c8b0] ${className}`}>
    <div className="flex items-start gap-3">
      <AlertTriangle className="w-5 h-5 text-[#a08050] shrink-0 mt-0.5" />
      <div className="text-sm text-[#6a5030] leading-relaxed whitespace-pre-line">
        {DISCLAIMER_TEXT}
      </div>
    </div>
  </div>
);

// Compact inline disclaimer
export const DisclaimerInline = ({ className = "" }) => (
  <div className={`flex items-center gap-2 text-xs text-foreground/50 ${className}`}>
    <AlertTriangle className="w-3 h-3 shrink-0" />
    <span>Not a substitute for professional medical or psychological advice.</span>
  </div>
);

// Terms Summary for Settings page
export const TermsSummary = ({ className = "" }) => (
  <div className={`space-y-3 ${className}`}>
    <h3 className="text-foreground font-medium text-sm">Terms of Use Summary</h3>
    <ul className="space-y-2 text-sm text-foreground/70">
      <li className="flex items-start gap-2">
        <span className="w-1.5 h-1.5 rounded-full bg-foreground/30 mt-2 shrink-0" />
        <span>Compass does not guarantee specific outcomes or results from using the platform.</span>
      </li>
      <li className="flex items-start gap-2">
        <span className="w-1.5 h-1.5 rounded-full bg-foreground/30 mt-2 shrink-0" />
        <span>You are fully responsible for all decisions and actions you take based on your use of Compass.</span>
      </li>
      <li className="flex items-start gap-2">
        <span className="w-1.5 h-1.5 rounded-full bg-foreground/30 mt-2 shrink-0" />
        <span>The platform is not liable for any outcomes resulting from your engagement with the content.</span>
      </li>
    </ul>
  </div>
);

export default DisclaimerFull;
